export const TRIMBLE_STYLE = Object.freeze({
  DARK: 'dark',
  LIGHT: 'light',
});
